/** "2026-10-10" -> "Oct 10, 2026" (dates are calendar days, so no time zone shifting) */
export function formatDate(day: string): string {
  const [y, m, d] = day.slice(0, 10).split('-').map(Number)
  if (!y || !m || !d) return ''
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  })
}

/** Today in the artist's own time zone, as YYYY-MM-DD */
export function today(): string {
  const now = new Date()
  const local = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
  return local.toISOString().slice(0, 10)
}

const BASE = (import.meta.env.VITE_IMAGE_BASE ?? '').replace(/\/+$/, '')

/** CloudFront serves stored images at /api/images/<key> */
export function imageUrl(key: string): string {
  return `${BASE}/api/images/${key.replace(/^\/+/, '')}`
}

export function tagPath(tag: string): string {
  return `/tag/${encodeURIComponent(tag)}`
}

export function comicPath(slug: string): string {
  return `/comic/${encodeURIComponent(slug)}`
}

/** Split a caption into text and [[Title]] / [[Title|words]] links */
export type CaptionPart = { text: string } | { title: string; label: string }

export function captionParts(caption: string): CaptionPart[] {
  const parts: CaptionPart[] = []
  const pattern = /\[\[([^\]|]+)(?:\|([^\]]+))?\]\]/g
  let last = 0
  for (const m of caption.matchAll(pattern)) {
    if (m.index! > last) parts.push({ text: caption.slice(last, m.index) })
    parts.push({ title: m[1].trim(), label: (m[2] ?? m[1]).trim() })
    last = m.index! + m[0].length
  }
  if (last < caption.length) parts.push({ text: caption.slice(last) })
  return parts
}

export function plural(n: number, one: string, many = `${one}s`): string {
  return `${n} ${n === 1 ? one : many}`
}
